import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Container} from 'views/components';

import {useLocation, ErrorBoundary} from 'views/module';
import {LinearProgress} from 'views/components';

import Navbar from 'views/module/appbar/navbar/Navbar';
import Status from 'views/module/status/Status';
import InternalServerError from './error/InternalServerError';

import LoggedInRoutes from './LoggedInRoutes';
import LoggedOutRoutes from './LoggedOutRoutes';

import ClientForm from './form/ClientForm';

const Site = (props) => {
  const location = useLocation();
  const user = props.user;
  const clientData = props.clientData;

  const showSite = Boolean(user?.lastLoadTime);
  const loggedIn = Boolean(user?.userRn);

  const clientStatus = clientData?.clientDetail?.status;

  if (showSite && !loggedIn) {
    return (
      <ErrorBoundary FallbackComponent={InternalServerError}>
        <Container
          maxWidth={false}
          disableGutters
          sx={{'backgroundColor': 'background.default'}}
        >
          <Status showProgressBar={true} location={location}/>
          <LoggedOutRoutes />
        </Container>
      </ErrorBoundary>
    );
  } else if (showSite && loggedIn && clientStatus && clientStatus !== 'LEAD' && clientStatus !== 'DETAILS_NEEDED') {
    return (
      <ErrorBoundary FallbackComponent={InternalServerError}>
        <Container
          maxWidth={false}
          disableGutters
          sx={{'backgroundColor': 'background.default'}}
        >
          <Navbar />
          <Status showProgressBar={true} location={location}/>
          <Container
            fixed
            disableGutters
            maxWidth={'xxl'}
            sx={{
              bgcolor: 'background.default',
              minHeight: '99vh',
              px: {lg: '8px', xs: '8px'},
              py: {lg: '16px', xs: '8px'},
              pl: {navbarHide: `312px`, sx: '0px'},
            }}
          >
            <ErrorBoundary FallbackComponent={InternalServerError}>
              <LoggedInRoutes />
            </ErrorBoundary>
          </Container>
        </Container>
      </ErrorBoundary>
    );
  } else if (showSite && loggedIn && clientStatus && (clientStatus === 'LEAD' || clientStatus === 'DETAILS_NEEDED')) {
    return (
      <ErrorBoundary FallbackComponent={InternalServerError}>
        <Container
          maxWidth={false}
          disableGutters
          sx={{'backgroundColor': 'background.default'}}
        >
          <Status showProgressBar={true} location={location}/>
          <Container
            fixed
            disableGutters
            maxWidth={'xxl'}
            sx={{
              bgcolor: 'background.default',
              minHeight: '99vh',
              px: {lg: '8px', xs: '8px'},
              py: {lg: '16px', xs: '8px'},
            }}
          >
            <ErrorBoundary FallbackComponent={InternalServerError}>
              <ClientForm />
            </ErrorBoundary>
          </Container>
        </Container>
      </ErrorBoundary>
    );
  } else {
    return (
      <LinearProgress color="secondary" />
    );
  }
};

Site.propTypes = {
  user: PropTypes.object,
  clientData: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
  clientData: state.clientData,
});

export default connect(mapStateToProps, dispatch)(React.memo(Site));
